module.exports = __webpack_public_path__ + "static/team-3-a134b53cec360776b691b5fd159d7539.png";